import { indexTopics } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Content Directory</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">内容频道</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">八大内容频道，覆盖你的所有观影需求</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {indexTopics.map((topic) => (
            <a
              key={topic.id}
              href="#hero"
              className="group bg-background-50 rounded-lg p-6 border border-secondary-200/60 hover:border-primary-300/40 transition-colors cursor-pointer block"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${topic.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-sm font-heading font-bold text-foreground-900">{topic.title}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}部</span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed">{topic.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}